import React, { FunctionComponent } from 'react';

import Button from '../Button';

const Close: FunctionComponent<{ handler?: Function }> = ({ handler }) => {
  return (
    <Button
      clickHandler={handler ? handler : () => {}}
      variant="outlined"
      size="small"
      style={{ padding: '1px 12px' }}
      color="#304ffe"
    >
      <span className="larger fwt mr5">&times;</span>Close
    </Button>
  );
};

export default Close;
